<template>
  <div>
    <div class="featured-section">
      <div class="fs__container">
        <div>
          <!--          <img src="/static/img/pages/home/featured/spotlight.webp?2"
                         srcset="/static/img/pages/home/featured/spotlight@2x.webp?2 1.5x,
                         /static/img/pages/home/featured/spotlight@2x.webp?2 2x,
                       /static/img/pages/home/featured/spotlight@3x.webp?2 3x"
                           class="fs__spotlight">-->
          <template v-for="row in featuredBiz">
            <div class="is-flex">
              <template v-for="biz in row">
                <featured-box :imgName="biz.imgName" :imgFormat="biz.imgFormat" :bizSlug="biz.bizSlug" :dimensions="'dimensions' in biz? biz.dimensions : null"/>
              </template>
            </div>
          </template>
        </div>
        <div class="fs__right">
          <div class="fs__right__head-box">
            <div class="font-mulish-bold fs__right__heading">Read & Write</div>
            <div>
              <img src="/static/img/pages/home/reviews.webp"
                   srcset="/static/img/pages/home/reviews@2x.webp 1.5x,
                   /static/img/pages/home/reviews@2x.webp 2x,
             /static/img/pages/home/reviews@3x.webp 3x"/>
            </div>
          </div>
          <business-search ref="bizSearch" @focus="handleBizSearchFocus">
            <button class="button hp-btn-primary" @click.prevent="showAllSearch">
              <template v-if="isDesktop">Find a business</template>
            </button>
          </business-search>
        </div>
        <div class="fs__blue-bg"></div>
      </div>
    </div>

    <!-- OLD -->
    <!-- <template v-if="!isMobileAds"> -->
    <!--   <ad v-on:ad-loaded="updateAdsListForPage" :ad-object="firstAd" :no-margin="hideFirstDesktopAd"></ad> -->
    <!--   <p class="has-text-centered"> -->
    <!--     <ad v-on:ad-loaded="updateAdsListForPage" :ad-object="secondAd"></ad> -->
    <!--   </p> -->
    <!-- </template> -->
    <!-- <template v-else> -->
    <!--   <p class="has-text-centered"> -->
    <!--     <ad v-on:ad-loaded="updateAdsListForPage" :ad-object="firstAd"></ad> -->
    <!--   </p> -->
    <!-- </template> -->
    <!-- NEW -->
    <p class="has-text-centered"><fuse-ad name="home_header" v-on:ad-loaded="updateAdsListForPage"></fuse-ad></p>
    <!-- <template v-if="!isMobileAds"> -->
    <!--   <p class="has-text-centered"> -->
    <!--     <fuse-ad name="home_header"></fuse-ad> -->
    <!--   </p> -->
    <!-- </template> -->
    <!-- <template v-else> -->
    <!--   <p class="has-text-centered"> -->
    <!--     <fuse-ad name="home_header"></fuse-ad> -->
    <!--   </p> -->
    <!-- </template> -->

    <div class="local-biz-section hp-container">
      <div class="hp-heading">Meet our best <span class="has-text-weight-normal">local businesses</span></div>
      <div class="has-text-centered" :class="{'font-size-14':isTablet, 'font-size-11':isMobile}">These companies are active and ready <br v-if="isMobile"/>to listen!</div>
      <div class="lbs-dd-row">
        <template v-if="isMobile">
          <a v-for="(dd, index) in industriesDd" :key="index" href="#" class="pill" :class="{'pill--selected':localBiz.selected.main === dd.options[0].value}"
             @click.prevent="bizStatusChangeHandler({value: dd.options[0].value, data:{isMain: true, mainName:dd.label}})">
            {{ dd.label }}
          </a>
        </template>
        <template v-else>
          <bulma-dropdown2 v-for="(dd, index) in industriesDd" :key="index" :ddLabel="dd.label" :ddOptions="dd.options" @bulmaDd2Change="bizStatusChangeHandler"/>
        </template>
        <router-link :to="{ name: 'IndustryLanding' }" class="link--v2">
          See All
        </router-link>
      </div>
      <loader v-if="isFetchingIndustryBusinesses"/>
      <template v-else>
        <flash-message class="margin-top-20" size="is-size-6"/>
        <biz-no-result v-if="!industryBusinesses.businesses.length"/>
        <VueSlickCarousel :variableWidth="true" :slidesToShow="localBiz__slidesToScroll" :slidesToScroll="localBiz__slidesToScroll" :infinite="!this.isDesktop" v-else>
          <div v-for="(business, idx) in industryBusinesses.businesses" :key="idx" class="lbs__biz-card">
            <img class="biz-card__logo" :src="bizLogo(business.business_logo_key.buckets[0].key)"/>
            <router-link :to="{name: 'BusinessDetail', params: { business: business.business_slug_key.buckets[0].key}}" class="biz-card__biz-link">
              <div>
                <div style="color: #000;" class="has-text-weight-bold is-capitalized">{{ business.business_name_key.buckets[0].key }}</div>
                <span class="color-gray is-uppercase">{{ localBiz.selected.mainName }}</span>
              </div>
              <div class="biz-card__info-box">
                <rating :isAvg="true" :stars="parseFloat(business.average_rating.value)"/>
                <div class="is-capitalized"><span class="has-text-weight-bold color-gray">{{ business.total_reviews.value }}</span> Reviews</div>
                <div><span class="has-text-weight-bold color-gray"># {{ idx + 1 }} </span> In {{ localBiz.selected.subName ? localBiz.selected.subName : localBiz.selected.mainName }}</div>
                <div><span class="has-text-weight-bold color-gray">{{ business.finalTrustIndex.value.toFixed(1) }}</span> <span class="has-text-weight-bold">Trust</span>Index Rating</div>
              </div>
            </router-link>
            <div><span class="color-gray">Recommend:</span> <span class="has-text-weight-bold">{{ npsRecommendation(npsScore(business.nps_key.buckets)) }}</span></div>
            <router-link :to="{ name: 'WriteReview' }" class="hp-btn-link">
              WRITE A REVIEW
            </router-link>
          </div>
          <template #prevArrow="arrowOption">
            <carousel-arrow dir="left"/>
          </template>
          <template #nextArrow="arrowOption">
            <carousel-arrow dir="right"/>
          </template>
        </VueSlickCarousel>
      </template>
    </div>

    <p class="has-text-centered">
      <fuse-ad v-if="!isMobileAds" name="home_Incontent_1" v-on:ad-loaded="updateAdsListForPage"></fuse-ad>
      <fuse-ad v-else name="home_mobile_hrec" v-on:ad-loaded="updateAdsListForPage"></fuse-ad>
      <!-- <ad v-on:ad-loaded="updateAdsListForPage" :ad-object="thirdAd"></ad> -->
    </p>

    <div class="publish-section">
      <div class="ps__container">
        <div class="ps__content-box">
          <div class="is-italic ps__content">“All experiences matter, and we believe sharing these are important. It’s a chance to help other consumers be more informed, help them make better choices, discover great businesses,
            and avoid
            the not so great
            ones.”
          </div>
          <div class="hp-heading"><span class="has-text-weight-normal">I want to write about</span> my experience</div>
          <router-link :to="{ name: 'WriteReview' }" class="hp-btn-link">
            PUBLISH MY REVIEW
          </router-link>
        </div>
      </div>
    </div>

    <p v-if="!isMobileAds" class="has-text-centered">
      <fuse-ad name="home_incontent_2" v-on:ad-loaded="updateAdsListForPage"></fuse-ad>
      <!-- <ad :ad-object="fourthAd" v-on:ad-loaded="updateAdsListForPage"></ad> -->
    </p>
    <p v-else class="has-text-centered">
      <fuse-ad name="home_incontent_2" v-on:ad-loaded="updateAdsListForPage"></fuse-ad>
      <!-- <ad v-on:ad-loaded="updateAdsListForPage" :ad-object="secondAd"></ad> -->
    </p>

    <div class="recent-reviews-section hp-container">
      <div class="hp-heading">Recent reviews <span class="has-text-weight-normal" :class="{'is-block':isMobile}">written by the community</span></div>
      <loader v-if="recentReviews.isLoading"/>
      <template v-else-if="isDesktop">
        <div class="is-flex">
          <div v-for="(list, index) in recentReviews.list" :key="index">
            <biz-review-card v-for="(review, index2) in list" :key="index2" :review="review"/>
          </div>
        </div>
      </template>
      <template v-else>
        <VueSlickCarousel v-for="(list, index) in recentReviews.list" :key="index" :arrows="false" :variableWidth="true">
          <biz-review-card v-for="(review, index2) in list" :key="index2" :review="review"/>
        </VueSlickCarousel>
      </template>
    </div>

    <div class="wa-section">
      <img class="valign-middle" :src="`${whatsappImg}_1x.png`" :srcset="`${whatsappImg}_2x.png 1.5x, ${whatsappImg}_2x.png 2x, ${whatsappImg}_3x.png 3x`"/>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import {adConfig, industries, misc} from '@/mixins'
import {Ad, BizNoResult, BusinessSearch, FlashMessage, Loader, Rating, CarouselArrow, FuseAd} from '@/components'
import {mapActions} from 'pinia'
import {useHeaderBizSearchStore} from '@/stores'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import {BulmaDropdown2} from '@/components/dropdowns'
import {BizReviewCard} from '@/components/reviewCards'
import FeaturedBox from "./FeaturedBox.vue";

export default {
  name: 'HomePage',
  components: {
    FeaturedBox,
    BusinessSearch,
    BizReviewCard,
    Ad,
    FuseAd,
    Rating,
    VueSlickCarousel,
    BulmaDropdown2,
    FlashMessage,
    Loader,
    BizNoResult,
    CarouselArrow
  },
  mixins: [adConfig, misc, industries],
  metaInfo () {
    return {
      title: 'Home - Review Companies Online | Customer Service & Company Ratings | hellopeter.com',
      meta: [{name: 'description', content: "As South Africa’s number one online review platform, Hellopeter is your go-to for writing reviews and researching businesses. Write a review and explore now."}],
      link: this.getMetaLinks
    }
  },
  data () {
    return {
      has_notification: false,
      equalHeightSet: false,
      equalHeightStyle: '',
      intervalId: '',
      featuredBiz: [
        [
          {
            imgName: 'miway_insurance',
            imgFormat: 'webp?2',
            bizSlug: 'miway',
            dimensions: {
              desktop: [130, 80],
              tablet: [143, 88],
              mobile: [80, 50]
            }
          },
          {
            imgName: 'rosebank_college',
            imgFormat: 'svg',
            bizSlug: 'rosebank-college'
          },
          {
            imgName: 'budget_insurance',
            imgFormat: 'jpg',
            bizSlug: 'budget-insurance',
            dimensions: {
              desktop: [130],
              tablet: [130],
              mobile: [80]
            }
          }
        ],
        [
          {
            imgName: 'gys_pitzer',
            imgFormat: 'webp',
            bizSlug: 'gys-pitzer-motors'
          },
          {
            imgName: 'home_connect',
            imgFormat: 'webp',
            bizSlug: 'home-connect'
          },
          {
            imgName: 'cartrack',
            imgFormat: 'webp?1',
            bizSlug: 'cartrack'
          }
        ],
        [
          {
            imgName: 'the_mattress_warehouse',
            imgFormat: 'webp',
            bizSlug: 'the-mattress-warehouse'
          },
          {
            imgName: 'king_price',
            imgFormat: 'svg',
            bizSlug: 'king-price-insurance'
          },
          {
            imgName: 'debt_rescue',
            imgFormat: 'webp',
            bizSlug: 'debt-rescue'
          }
        ]
      ],
      recentReviews: {
        isLoading: false,
        list: [],
      },
      localBiz: {
        selected: {
          main: '',
          mainName: '',
          sub: '',
          subName: ''
        },
        mainIndustries: {
          'desktop': ['insurance', 'banking-financial-services', 'automotive', 'retail'],
          'tablet': ['insurance', 'banking-financial-services'],
          'mobile': ['insurance', 'automotive', 'retail']
        }
      }
    }
  },
  computed: {
    getMetaLinks () {
      return [
        {
          rel: 'canonical',
          href: `${window.location.protocol}//${window.location.host}`
        }
      ]
    },
    industriesAndReviews () {
      const reviewLength = this.recentReviews.list.length
      const industryLength = parseInt(this.hasIndustriesFetched)
      return `${reviewLength},${industryLength}`
    },
    localBiz__slidesToScroll () {
      return this.isDesktop ? 3 : 1
    },
    whatsappImg () {
      return `/static/img/pages/home/whatsapp/${this.deviceType}`
    },
    industriesDd () {
      const dds = []

      const mainIndustries = this.localBiz.mainIndustries[this.deviceType]
      if (mainIndustries.length && this.hasIndustriesFetched) {
        mainIndustries.forEach(mainIndustry => {
          const ind = this.industriesWithoutAll.find(industry => industry.slug === mainIndustry) || {}
          if (!(_.isEmpty(ind))) {
            let ddOptions = []

            if (!this.isMobile) {
              ddOptions = ind.sub_industries.map(subInd => ({
                label: subInd.name,
                value: subInd.slug,
                data: {isMain: false, mainSlug: ind.slug, mainName: ind.name}
              }))
            }

            ddOptions.unshift({
              label: "All",
              value: ind.slug,
              data: {isMain: true, mainName: ind.name},
              selected: ind.slug === mainIndustries[0]
            })

            dds.push({
              label: ind.name,
              options: ddOptions
            })
          }
        })

        if (!this.isMobile) {
          const moreOptions = []
          this.industriesWithoutAll.forEach(industry => {
            if (!mainIndustries.includes(industry.slug)) {
              moreOptions.push({
                label: industry.name,
                value: industry.slug,
                data: {isMain: true, mainName: industry.name}
              })
            }
          })
          dds.push({
            label: 'More',
            options: moreOptions
          })
        }
      }

      return dds
    }
  },
  created () {
    this.getFeaturedReviews()

    if (this.isMobile && this.industriesDd.length) {
      this.bizStatusChangeHandler({value: this.industriesDd[0].options[0].value, data: {isMain: true, mainName: this.industriesDd[0].label}})
    }
  },
  mounted () {
    this.$gtm.trackEvent({
      event: 'pageLoad',
      virtualPageUrl: this.$router.currentRoute.path,
      virtualPageTitle: 'Home'
    })
    this.matchHeight()
    // this.loadFuseAds()
    // this.loadAds()
    this.has_notification = typeof this.$route.query.notification !== 'undefined' && this.$route.query.notification.length > 0
  },
  beforeDestroy () {
    clearInterval(this.interactionHandler)
  },
  methods: {
    ...mapActions(useHeaderBizSearchStore, ['turnOnSearchMode']),
    bizStatusChangeHandler (data) {
      let resp
      const bizListFilers = {
        bizStatus: 'all',
        sortBy: 'most_relevant',
        startFrom: 0
      }
      if (data.data.isMain) {
        bizListFilers.indSlug = data.value
        this.localBiz.selected.sub = ''
        this.localBiz.selected.subName = ''
        resp = this.fetchIndustryBusinesses(bizListFilers)
      } else {
        bizListFilers.indSlug = data.data.mainSlug
        this.localBiz.selected.sub = data.value
        this.localBiz.selected.subName = data.label
        resp = this.fetchSubIndustryBusinesses(data.value, bizListFilers)
      }
      this.localBiz.selected.main = bizListFilers.indSlug
      this.localBiz.selected.mainName = data.data.mainName
      resp.catch(_ => {
        flash('There was an error fetching the businesses. Please try again later!', 'is-danger')
      })
      flash('There was an error fetching the businesses. Please try again later!', 'is-danger')
    },
    handleBizSearchFocus () {
      if (!this.isDesktop) {
        this.turnOnSearchMode()
      }
    },
    showAllSearch () {
      this.$refs.bizSearch.forwardSearch(this.$refs.bizSearch.searchString)
    },
    getFeaturedReviews () {
      this.recentReviews.isLoading = true
      axios.get('/consumer/featured-reviews')
        .then(({data}) => {
          this.recentReviews.list = [data.slice(0, 3), data.slice(3)]
          this.recentReviews.isLoading = false
        })
    },
    matchHeight () {
      let intervalFunction = () => {
        if (!this.equalHeightSet) {
          const refOne = this.$refs.reviewItem_0
          const refTwo = this.$refs.reviewItem_1
          const refThree = this.$refs.reviewItem_2
          const refFour = this.$refs.reviewItem_3
          if (typeof refOne !== 'undefined' && typeof refTwo !== 'undefined' && typeof refThree !== 'undefined' && typeof refFour !== 'undefined') {
            const heightOne = refOne[0].clientHeight
            const heightTwo = refTwo[0].clientHeight
            const heightThree = refThree[0].clientHeight
            const heightFour = refFour[0].clientHeight
            const biggestNumber = Math.max(heightOne, heightTwo, heightThree, heightFour)
            this.equalHeightStyle = `height:${biggestNumber}px!important;`
            this.equalHeightSet = true
          }
        }
      }
      this.intervalId = setInterval(intervalFunction, 1000)
    },
  },
  watch: {
    industriesAndReviews () {
      window.prerenderReady = true
    },
    has_notification () {
      if (this.has_notification) {
        const header = this.error ? 'is-danger' : 'is-success'
        flash(this.$route.query.notification, header, true)
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/_variables.scss";
@import "@/assets/scss/vendor/_breakpoints.scss";

.featured-section {
  background-color: map-get($colors, 'gray-light');

  @include not-desktop {
    background: url("/static/img/pages/home/blue_circle.svg") map-get($colors, 'gray-light') no-repeat right center/auto 100%;
  }

  .fs__container {
    position: relative;
    display: flex;
    background: url("/static/img/pages/home/blue_circle.svg") no-repeat right center/auto 100%;
    padding: 12px 58px 0 53px;
    height: 695px;
    align-items: center;
    max-width: 1400px;
    margin: auto;

    @include not-desktop {
      padding-top: 53px;
      padding-bottom: 71px;
      max-width: 705px;
      flex-direction: column;
      height: auto;
      background: none;

      > div:first-child {
        order: 2;
        margin-top: 95px;
      }
    }

    @include mobile {
      padding: 33px 2px 47px 7px;

      > div:first-child {
        margin-top: 40px;
      }
    }

    /*@include desktop {
      .fs__spotlight {
        min-width: 550px;
        max-width: 550px;
        margin-right: 20px;
      }
    }*/

    .fs__right {
      margin-left: auto;
      margin-top: -10px;
      margin-right: 15px;

      @include not-desktop {
        margin-top: 0;
        margin-right: 0;
      }

      @include mobile {
        margin: auto;
      }

      .fs__right__head-box {
        @include mobile {
          width: 310px;
          padding: 0;
        }

        .fs__right__heading {
          color: map-get($colors, 'blue-dark');
          font-size: 60px;
          line-height: 55px;

          @include not-desktop {
            line-height: unset;
          }

          @include mobile {
            font-size: 35px;
          }
        }

        img {
          position: relative;
          left: -2.5%;
          margin-top: -4.5%;

          @include tablet {
            margin-top: -46px;
            left: -17px;
          }

          @include mobile {
            margin-top: -23px;
            left: -9px;
          }
        }
      }

      > > > .search-block {
        margin: 0;
        max-width: 589px;

        @include mobile {
          max-width: 100%;
        }

        .dropdown-content {
          box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.5);
        }

        .search-block-field {
          height: 45px;
          box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.51);
          font-size: 16px;
          background: url("/static/img/magnifier/magnifier2_blue_dark.png") #fff no-repeat left 18px center/20px;
          padding-left: 49px;
          width: 100%;
          padding-right: 190px;

          @include not-desktop {
            background-image: none;
            padding-left: 22px;
            padding-right: 89px;
          }

          @include mobile {
            box-shadow: none;
            height: 40px;
            font-size: 13px;
            padding-top: 7px;
            padding-left: 13px;
            padding-right: 58px;
          }

          & + .button {
            width: 180px;
            height: 45px;
            border-radius: 22.5px;
            text-transform: uppercase;
            font-weight: bold;
            position: absolute;
            top: 0;
            right: 0;

            @include not-desktop {
              width: 79px;
              background: url("/static/img/magnifier/magnifier2_white.png") map-get($colors, 'blue-dark') no-repeat center center/21px;
            }

            @include mobile {
              height: 40px;
              width: 55px;
              background-size: 19px auto;
            }
          }
        }
      }
    }

    .fs__blue-bg {
      position: absolute;
      background-color: #eff2fa;
      top: 0;
      height: 100%;

      @include desktop {
        left: 100%;
        right: -9999px;
      }
    }
  }
}

.local-biz-section {
  color: map-get($colors, 'blue-dark');
  padding: 0 4px;
  margin-top: 30px;
  margin-bottom: 30px;

  @include tablet {
    font-size: 12px;
    padding: 0 91px 0 68px;
  }

  @include mobile {
    font-size: 12px;
    padding: 0 28px 41px 23px;
  }

  .hp-heading {
    font-size: 40px;
    text-align: center;
    line-height: 48px;

    @include tablet {
      font-size: 30px;
      line-height: 40px;
    }

    @include mobile {
      font-size: 20px;
      line-height: 30px;
    }
  }

  .lbs-dd-row {
    margin: 26px 0 24px;
    text-align: center;

    @include tablet {
      margin: 28px 0 39px;
    }

    @include mobile {
      margin: 15px 0 0;

      .pill {
        font-size: 10px;
      }
    }

    .c-dropdown:not(:last-child) {
      margin-right: 26px;

      @include tablet {
        margin-right: 17px;
      }
    }

    .link--v2 {
      padding-top: 5px;
      display: inline-block;

      @include tablet {
        padding-top: 9px;
      }
    }
  }

  @include mobile {
    .link--v2 {
      margin-right: 11px;
    }
  }

  > > > .no-results {
    .no-results__para {
      display: none;
    }

    .no-results__sub-head {
      margin-top: 0;
    }
  }

  .lbs__biz-card {
    padding: 59px 22px 24px;
    border-radius: 25px;
    box-shadow: 1px 1px 10px 0 rgba(0, 0, 0, 0.16);
    border: 0.5px solid #c1c1c1;
    position: relative;
    text-align: center;
    margin-top: 79px;

    @include not-desktop {
      padding: 49px 10px 18px;
      border-radius: 15px;
      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.16);
      margin-top: 44px;
    }

    .biz-card__logo {
      position: absolute;
      top: -50px;
      left: 0;
      right: 0;
      margin-left: auto;
      margin-right: auto;
      max-width: 100px;
      border-radius: 50%;

      @include not-desktop {
        width: 80px;
        top: -40px;
      }
    }

    .biz-card__biz-link {
      color: map-get($colors, 'blue-dark');
    }

    .biz-card__info-box {
      padding: 10px 0 11px;
      border-radius: 20px;
      background-color: rgba(112, 112, 112, 0.05);
      margin-top: 13px;
      line-height: 27px;
      margin-bottom: 22px;

      @include not-desktop {
        font-size: 11px;
        line-height: 19px;
        padding: 9px 0 8px;
        margin-bottom: 11px;
      }

      > > > .star-new {
        @include mobile {
          margin-bottom: 3px;
        }

        ul {
          margin: 0 auto;

          li {
            font-size: 1em;
            margin-left: 7px;

            @include not-desktop {
              margin-left: 6px;
              font-size: 1.1em;
            }
          }
        }
      }
    }

    .hp-btn-link {
      margin-top: 18px;

      @include not-desktop {
        margin-top: 14px;
        width: 130px;
        font-size: 12px;
        padding: 8px 0;
      }
    }
  }

  > > > .slick-slide {
    width: 356px;
    padding-left: 12.5px;
    padding-right: 12.5px;

    @include tablet {
      width: 266px;
      padding-left: 7.5px;
      padding-right: 7.5px;
    }

    @include mobile {
      width: 268px;
      padding-left: 8px;
      padding-right: 8px;
    }
  }

  .custom-arrow.slick-prev {
    left: -18px;

    @include not-desktop {
      left: -8px;
      width: 9px;
    }
  }

  .custom-arrow.slick-next {
    right: -17px;

    @include not-desktop {
      right: -30px;
      width: 9px;
    }

    @include mobile {
      right: -5px;
    }
  }
}

.publish-section {
  max-width: 1400px;
  margin: 0 auto 30px;

  .ps__container {
    background: url('/static/img/pages/home/pillar_left.svg') left 0 no-repeat, url('/static/img/pages/home/pillar_right.svg') right 0 no-repeat, map-get($colors, 'gray-light');
    color: map-get($colors, 'blue-dark');
    padding: 56px 0 60px;

    @include tablet {
      padding: 29px 0 30px;
      background-size: 65px auto;
    }

    @include mobile {
      padding: 19px 0 20px;
      background: url('/static/img/pages/home/pillar_left_mobile.svg') left no-repeat, url('/static/img/pages/home/pillar_right_mobile.svg') right no-repeat, map-get($colors, 'gray-light');
    }

    .ps__content-box {
      max-width: 800px;
      text-align: center;
      margin: 0 auto;

      @include tablet {
        max-width: 500px;
      }

      @include mobile {
        max-width: 250px;
      }

      .hp-heading {
        margin: 36px 0;
        font-size: 30px;

        @include tablet {
          font-size: 24px;
          margin: 23px 0 26px;
        }

        @include mobile {
          font-size: 18px;
          margin: 10px 0 9px;
        }
      }

      .hp-btn-link {
        color: map-get($colors, 'yellow');
        width: 250px;
        height: 55px;
        padding: 16px 0;
        font-size: 16px;
        border-radius: 27.5px;

        @include tablet {
          height: 45px;
          font-size: 14px;
          padding: 12px 0;
        }

        @include mobile {
          height: 35px;
          font-size: 13px;
          padding: 8px 0;
        }
      }
    }

    .ps__content {
      line-height: 30px;

      @include tablet {
        font-size: 14px;
        line-height: 22px;
      }

      @include mobile {
        font-size: 12px;
        line-height: 20px;
      }
    }
  }

}

.recent-reviews-section {
  padding-bottom: 66px;

  @include tablet {
    padding-bottom: 1px;
    padding-left: 45px;
    padding-right: 0;
  }

  @include mobile {
    padding-left: 0;
    padding-right: 0;
    padding-bottom: 6px;
  }

  .hp-heading {
    font-size: 40px;
    text-align: center;
    margin-bottom: 28px;

    @include tablet {
      font-size: 30px;
      margin-bottom: 25px;
    }

    @include mobile {
      font-size: 20px;
      margin-bottom: 21px;
    }
  }

  > > > .slick-list {
    @include mobile {
      padding: 0 16px;
    }

    .slick-slide {
      @include tablet {
        width: 525px;
        padding-left: 12.5px;
        padding-right: 12.5px;
        padding-top: 5px;
      }

      @include mobile {
        width: 288px;
        padding-left: 4px;
        padding-right: 4px;
      }
    }
  }
}

.wa-section {
  text-align: center;
  background-color: map-get($colors, 'gray-light');
  height: 701px;
  line-height: 701px;

  @include tablet {
    height: 585px;
    line-height: 585px;
  }

  @include mobile {
    height: 281px;
    line-height: 281px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/Home.vue